// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r2-2";
export var chatLink = "_r2-0";
export var chatText = "_r2-1";